import { OrgAdminConstants } from '../../../_constants';

const initialState = { addPaUsersLoading: true, data: '', error: false };

export function addPaUsers(state = initialState, action) {

    switch (action.type) {
        case OrgAdminConstants.REQUEST_ADD_PA_USERS:
            return {
                addPaUsersLoading: true,
                data: '',
                error: false
            };
        case OrgAdminConstants.RECEIVE_ADD_PA_USERS:
            return {
                addPaUsersLoading: false,
                data: action.getOrgUser,
                error: false
            };
        case OrgAdminConstants.ADD_PA_USERS_ERROR:
            return {
                addPaUsersLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/OrgAdmin/PaUsers/addPaUsers.reducer.js